module.exports = function() {
  return new Worker(__webpack_public_path__ + "1f04dec37450e74d.worker.js");
};